import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import transformDealerStatusResponse, { transformDealerAvailabilityResponse } from '../apiResponseTransformers/dealer';
const dealerApi = createApi({
    reducerPath: 'dealerApi',
    baseQuery: fetchBaseQuery(),
    endpoints: builder => ({
        getDealerStatus: builder.query({
            query: ({ url, headers, params }) => ({
                url,
                headers,
                params,
            }),
            transformResponse: transformDealerStatusResponse,
        }),
        getDealerAvailability: builder.query({
            query: ({ url, headers }) => ({
                url,
                headers,
            }),
            transformResponse: transformDealerAvailabilityResponse,
        }),
    }),
});
export const dealerApiReducer = dealerApi.reducer;
export const dealerApiMiddleware = dealerApi.middleware;
export default dealerApi;
export const { useGetDealerStatusQuery, useGetDealerAvailabilityQuery } = dealerApi;
